import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../utils/authContext.js";
import LoadingSpinner from "../LoadingSpinner/loadingSpinner.js";

/**
 * AuthGuard component - Protects routes that require authentication
 * Uses AuthContext instead of useAuth hook for single source of truth
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {JSX.Element} Protected content or redirect to login
 */
const AuthGuard = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="h-screen w-full flex flex-col items-center justify-center bg-white dark:bg-[#0d1117]">
                <LoadingSpinner />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default AuthGuard;